import React, { useState } from 'react';
import ContentLoader, { Circle, Rect } from 'react-content-loader/native';
import { SafeAreaView, View } from 'react-native';
import LogoSVG from '~/credsystem/assets/svgs/marisa-logo.svg';
import EyeOpenSVG from '~/credsystem/assets/svgs/eye-open.svg';
import ProfileCircleSVG from '~/credsystem/assets/svgs/profile-circle.svg';
import colors from '~/assets/themes/colors';
import ArrowLeftSVG from '~/assets/svgs/arrow-left.svg';

import { SCREEN_WIDTH } from '~/utils/device';

const DEFAULT_WIDTH = SCREEN_WIDTH - 48;

const Loader: React.FC = () => {
  const [containerWidth, setContainerWidth] = useState(0);

  return (
    <SafeAreaView className="bg-light-100 h-full">
      <View
        className="bg-primary-600 p-6 pb-14 rounded-b-3xl"
        onLayout={(e) => setContainerWidth(e.nativeEvent.layout.width)}
      >
        <View className="flex-row items-center justify-between">
          <ArrowLeftSVG color={colors.light[100]} />

          <View className="ml-11">
            <LogoSVG />
          </View>

          <View className="flex-row items-center">
            <View className="mr-5">
              <EyeOpenSVG />
            </View>
            <ProfileCircleSVG />
          </View>
        </View>

        <View className="mt-6 flex-row justify-between">
          <View>
            <ContentLoader
              animate
              width={150}
              height={50}
              backgroundColor={colors.primary[400]}
            >
              <Rect width={150} rx={3} ry={3} height="20" />
              <Rect y="26" rx={3} ry={3} width={100} height="20" />
            </ContentLoader>
          </View>
          <View>
            <ContentLoader
              animate
              width={150}
              height={50}
              backgroundColor={colors.primary[400]}
            >
              <Rect width={125} y={0} x={25} rx={3} ry={3} height="20" />
            </ContentLoader>
          </View>
        </View>

        <View className="items-center justify-center">
          <ContentLoader
            animate
            width={SCREEN_WIDTH}
            height={308}
            backgroundColor={colors.primary[400]}
          >
            <Circle cx="50%" cy="50%" r="120" />
          </ContentLoader>
        </View>
      </View>

      <View className="mt-[-80px] flex-row justify-between">
        <>
          <ContentLoader
            animate
            width={DEFAULT_WIDTH}
            height={160}
            backgroundColor={colors.primary[400]}
          >
            <Rect
              width={140}
              x={containerWidth / 2 - 280 / 2 - 8}
              rx={3}
              ry={3}
              height="30"
            />

            <Rect
              width={140}
              x={containerWidth / 2 + 8}
              rx={3}
              ry={3}
              height="30"
            />

            <Rect
              x={containerWidth / 2 - 60 - 8}
              y={50}
              rx={3}
              ry={3}
              width={'60'}
              height="60"
            />
            <Rect
              x={containerWidth / 2 - 60 - 8}
              y={114}
              rx={3}
              ry={3}
              width={'60'}
              height="16"
            />

            <Rect
              x={containerWidth / 2 + 8}
              y={50}
              rx={3}
              ry={3}
              width={'60'}
              height="60"
            />
            <Rect
              x={containerWidth / 2 + 8}
              y={114}
              rx={3}
              ry={3}
              width={'60'}
              height="16"
            />
          </ContentLoader>
        </>
      </View>
    </SafeAreaView>
  );
};

export default Loader;
